exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "optgroup[data-v-88cca846] {\n  background-color: #e7e2e2;\n  color: gray;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n}\noptgroup option[data-v-88cca846] {\n    color: #06263e;\n    font-size: 12px;\n    font-weight: 700;\n}\n.required[data-v-88cca846] {\n  color: red;\n}\n", ""]);

// exports
